
  
  
 import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaEye,
  FaCheck,
  FaCertificate,
  FaDownload,
  FaSearch,
} from "react-icons/fa";
import {
  MdApps,
  MdBadge,
  MdBuild,
  MdBusiness,
  MdBusinessCenter,
  MdCategory,
  MdDashboard,
  MdEvent,
  MdGrade,
  MdGroup,
  MdHome,
  MdImage,
  MdInsertChart,
  MdLink,
  MdList,
  MdMenu,
  MdPerson,
  MdPhotoLibrary,
  MdPostAdd,
  MdSettings,
  MdSlideshow,
  MdStar,
  MdStore,
  MdTv,
  MdVerified,
  MdWork,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FacebookEmbed,
  InstagramEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"
import { State, City } from "country-state-city";
import './Admin.css';

const API = "https://api.propertygalleria.in";
  
 export const Properties = () => { 
  

// -------- Properties -------- //
const [properties, setProperties] = useState([]);
const [categoriesP, setCategoriesP] = useState([]);
const [typesP, setTypesP] = useState([]);

const [showModalP, setShowModalP] = useState(false);
const [editingIDP, setEditingIDP] = useState(null);

const [formP, setFormP] = useState({
  category_id: "",
  type_id: "",
  property_name: "",
  location: "",
  state:"",
  city:"",
  image: null,
});

// Pagination (SAME AS SLIDERS)
const [currentPageP, setCurrentPageP] = useState(1);
const itemsPerPageP = 5;
const totalPagesP = Math.ceil(properties.length / itemsPerPageP);

const currentItemsP = properties.slice(
  (currentPageP - 1) * itemsPerPageP,
  currentPageP * itemsPerPageP
);



const fetchProperties = async () => {
  const { data } = await axios.get(`${API}/api/properties`);
  setProperties(data);
};

const fetchCategories = async () => {
  const { data } = await axios.get(`${API}/api/new/property-categories`);
  setCategoriesP(data);
};

const fetchTypes = async (catId) => {
  const { data } = await axios.get(`${API}/api/new/property-types/${catId}`);
  setTypesP(data);
};

useEffect(() => {
  fetchProperties();
  fetchCategories();
}, []);


// const handleSubmitP = async (e) => {
//   e.preventDefault();

//   const fd = new FormData();
//   fd.append("category_id", formP.category_id);
//   fd.append("type_id", formP.type_id);
//   fd.append("property_name", formP.property_name);
//   fd.append("location", formP.location);
//   if (formP.image instanceof File) fd.append("image", formP.image);

//   if (editingIDP) {
//     await axios.put(`${API}/api/properties/${editingIDP}`, fd);
//   } else {
//     await axios.post(`${API}/api/properties`, fd);
//   }

//   setShowModalP(false);
//   setEditingIDP(null);
//   setFormP({
//     category_id: "",
//     type_id: "",
//     property_name: "",
//     location: "",
//     image: null,
//   });
//   fetchProperties();
// };


const handleSubmitP = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append("category_id", formP.category_id);
  fd.append("type_id", formP.type_id);
  fd.append("property_name", formP.property_name);
  fd.append("location", formP.location);
 fd.append("state", formP.state);
 fd.append("city", formP.city);

  // MUST append image
  if (formP.image) {
    fd.append("image", formP.image);
  }

  try {
    if (editingIDP) {
      await axios.put(
        `${API}/api/properties/${editingIDP}`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      await axios.post(
        `${API}/api/properties`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    }

    setShowModalP(false);
    setEditingIDP(null);
    setFormP({
      category_id: "",
      type_id: "",
      property_name: "",
      location: "",
      state:"",
      city:"",
      image: null,
    });

    fetchProperties();
  } catch (error) {
    console.error("Upload error:", error.response?.data || error.message);
  }
};


const handleEditP = (p) => {
  setEditingIDP(p.id);
  setFormP({
    category_id: p.category_id,
    type_id: p.type_id,
    property_name: p.property_name,
    location: p.location,
    state:p.state,
    city:p.city,
    image: p.image,
  });
  fetchTypes(p.category_id);
  setShowModalP(true);
};

const handleDeleteP = async (id) => {
  if (!window.confirm("Delete this property?")) return;
  await axios.delete(`${API}/api/properties/${id}`);
  fetchProperties();
};

const states = State.getStatesOfCountry("IN");

  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Properties</h2>

        <button
          onClick={() => {
            setFormP({
              category_id: "",
              type_id: "",
              property_name: "",
              location: "",
              state:"",
              city:"",
              image: null,
            });
            setEditingIDP(null);
            setShowModalP(true);
          }}
          style={{
            background:
              "linear-gradient(135deg, var(--pg-primary), var(--pg-accent))",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #42987e" }}>
        <thead style={{ background: "var(--pg-primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Category</th>
            <th>Type</th>
            <th>Name</th>
            <th>Location</th>
            <th>State&City</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsP.map((p, i) => (
            <tr key={p.id}>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.category_name}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.type_name}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.property_name}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.location}</td>
 <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{p.state}/{p.city}</td>
              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <img
                  src={p.image}
                  alt=""
                  style={{ width: 100, borderRadius: 6 }}
                />
              </td>

              <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                <button
                  onClick={() => handleEditP(p)}
                  style={{
                    background: "#fff",
                    color: "var(--pg-primary)",
                    marginRight: 10,
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => handleDeleteP(p.id)}
                  style={{
                    background: "#fff",
                    color: "var(--pg-secondary)",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPagesP > 1 && (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <button
            disabled={currentPageP === 1}
            onClick={() => setCurrentPageP((p) => p - 1)}
          >
            Prev
          </button>

          {Array.from({ length: totalPagesP }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPageP(page)}
              style={{
                background:
                  currentPageP === page
                    ? "var(--pg-secondary)"
                    : "#fff",
                color: currentPageP === page ? "#fff" : "#333",
              }}
            >
              {page}
            </button>
          ))}

          <button
            disabled={currentPageP === totalPagesP}
            onClick={() => setCurrentPageP((p) => p + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {showModalP && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 450,
              padding: 25,
                  /* ✅ ADD THESE */
    maxHeight: "90vh",
    overflowY: "auto",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between",marginBottom:'20px' }}>
              <h3>
                {editingIDP ? "Edit Property" : "Add Property"}
              </h3>
              <FaTimes
                onClick={() => setShowModalP(false)}
                style={{ cursor: "pointer" }}
              />
            </div>

      <form onSubmit={handleSubmitP}>
  <label style={labelStyle}>Category</label>
  <select
    style={inputStyle}
    value={formP.category_id}
    onChange={(e) => {
      setFormP({ ...formP, category_id: e.target.value, type_id: "" });
      fetchTypes(e.target.value);
    }}
    required
  >
    <option value="">Select Category</option>
    {categoriesP.map((c) => (
      <option key={c.id} value={c.id}>
        {c.category_name}
      </option>
    ))}
  </select>

  <label style={labelStyle}>Type</label>
  <select
    style={inputStyle}
    value={formP.type_id}
    onChange={(e) =>
      setFormP({ ...formP, type_id: e.target.value })
    }
    required
  >
    <option value="">Select Type</option>
    {typesP.map((t) => (
      <option key={t.id} value={t.id}>
        {t.type_name}
      </option>
    ))}
  </select>

  <label style={labelStyle}>Property Name</label>
  <input
    style={inputStyle}
    type="text"
    value={formP.property_name}
    onChange={(e) =>
      setFormP({ ...formP, property_name: e.target.value })
    }
    required
  />

  {/* <label style={labelStyle}>Location</label>
  <input
    style={inputStyle}
    type="text"
    value={formP.location}
    onChange={(e) =>
      setFormP({ ...formP, location: e.target.value })
    }
    required
  /> */}
<label style={labelStyle}>State</label>
<select
  style={inputStyle}
  value={formP.state}
  onChange={(e) =>
    setFormP({
      ...formP,
      state: e.target.value,
      city: "" // reset city when state changes
    })
  }
  required
>
  <option value="">Select State</option>
  {states.map((state) => (
    <option key={state.isoCode} value={state.isoCode}>
      {state.name}
    </option>
  ))}
</select>
<label style={labelStyle}>City</label>
<select
  style={inputStyle}
  value={formP.city}
  onChange={(e) =>
    setFormP({ ...formP, city: e.target.value })
  }
  required
  disabled={!formP.state}
>
  <option value="">Select City</option>
  {City.getCitiesOfState("IN", formP.state).map((city) => (
    <option key={city.name} value={city.name}>
      {city.name}
    </option>
  ))}
</select>

  <label style={labelStyle}>Image</label>
  <input
    style={inputStyle}
    type="file"
    onChange={(e) =>
      setFormP({ ...formP, image: e.target.files[0] })
    }
  />

  {formP.image && (
    <img
      src={
        typeof formP.image === "string"
          ? formP.image
          : URL.createObjectURL(formP.image)
      }
      style={{ width: 100, borderRadius: 8, marginBottom: 10 }}
      alt=""
    />
  )}

  <button
    type="submit"
    style={{
      background: "var(--pg-secondary)",
      color: "#fff",
      padding: "10px",
      width: "100%",
      borderRadius: 6,
      border: "none",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    {editingIDP ? "Update" : "Add"}
  </button>
</form>

          </div>
        </div>
      )}
    </div>
  );

}


/* ---------- Styles ---------- */

const baseStyles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Segoe UI, sans-serif",
   /* PG ADMIN BACKGROUND */
background: "var(--pg-bg)",

  },
  sidebar: {
   background: "linear-gradient(180deg, var(--pg-primary), var(--pg-accent))",
    color: "#fff",
    transition: "width 0.3s ease",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    padding: "15px 10px",
    boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  logoArea: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  logoBlock: { lineHeight: 1.2,     marginTop: "8px", marginBottom: "8px",  },

  logoAccent: {
    color: "var(--pg-secondary)",
    fontWeight: "700",
    fontSize: "0.85rem",
    marginLeft: "4px",
       background: "rgba(255, 255, 255, 0.5)",
borderRadius: "8px",
 textTransform:"uppercase",
 padding:'5px',
  filter: "drop-shadow(0 2px 8px #fff)",

  },
  logoTagline: {
    fontSize: "0.7rem",
    color: "#c9d1d9",
    marginTop: "3px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    marginBottom: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  navIcon: { fontSize: "18px", marginRight: "10px" },
  navLabel: { fontSize: "15px", fontWeight: "500" },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? "220px" : "70px",
    transition: "margin-left 0.3s ease",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentWrapper: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
 logoContainer: {
    display: "inline-flex", // Ensures it aligns well with other text elements
    justifyContent: "center", // Centers the text horizontally
    alignItems: "center", // Centers the text vertically
   background: "rgba(255, 255, 255, 0.5)", borderRadius: "50%", // Ensures the shape is a circle filter: "drop-shadow(0 2px 8px #fff)", // Makes the whole container circular
   width: "42px",  height: "42px", // Set a fixed height (should match width for a circle) padding: "0",, // Padding to create space around the letters
    filter: "drop-shadow(0 2px 8px #fff)", // Same drop shadow for the whole logo
  },

  logoMain: { fontWeight: "800", color: "#fff", fontSize: "1.1rem", letterSpacing: "0.5px",    marginTop: "14px",     textTransform: "uppercase",  },

  logoMain1: {
    color: "var(--pg-primary)", // Color for "P" (if you want to change, do it here)
    fontWeight: "800",
    fontSize: "1.3rem",
    letterSpacing: "0.5px",
    marginRight: "1px", // Margin to separate "P" from "G"
  },

  logoG: {
    color: "var(--pg-secondary)", // Color for "G"
    fontWeight: "700",
    fontSize: "1.3rem",
    
  },
};

const headerStyles = {
  header: {
    height: "60px",
 /* PG HEADER THEME */
background: "linear-gradient(90deg, var(--pg-primary), var(--pg-secondary))",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  leftGroup: { display: "flex", alignItems: "center" },
  toggleBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  },
  profileArea: { position: "relative" },
  profileMenu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 10px)",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  profileMenuItem: {
    padding: "10px 10px",
    cursor: "pointer",
    color: "var(--pg-primary)",
    fontWeight: 500,
    borderBottom: "1px solid #eee",
   width:'160px'
  },
};

const contentStyles = {
 wrapper: {
/* PG GLASS CARD */
background: "rgba(255,255,255,0.92)",
backdropFilter: "blur(14px)",
border: "1px solid rgba(139,48,109,0.12)",

    borderRadius: "18px",
    padding: "35px",
    boxShadow:
      "0 14px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(8px)",
    transition: "0.3s ease-in-out",
  },

  title: {
    margin: 0,
    marginBottom: "14px",
    fontSize: "1.9rem",
    fontWeight: "700",
    letterSpacing: "0.6px",
    background: "var(--pg-primary)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    margin: 0,
    marginTop: "5px",
    fontSize: "1rem",
    color: "#555",
    fontWeight: "500",
    opacity: 0.85,
  },
  formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    flex: "0.3",
  },
  fileInput: {
    flex: "0.5",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  addBtn: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thead: { background: "var(--primary)", color: "#fff" },
  th: {
    textAlign: "left",
    padding: "10px",
    fontWeight: "600",
  },
  td: { padding: "10px", borderBottom: "1px solid #eee" },
  btnEdit: {
    background: "var(--primary)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
  },
  btnDelete: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  noData: { color: "#888", textAlign: "center", padding: "20px" },
};


const labelStyle = {
  display: "block",
  textAlign: "left",
  fontWeight: 600,
  marginBottom: 5,
    marginLeft: 5,
  color: "#333"
};

const inputStyle = {
  width: "95%",
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: "8px",
  fontSize: 14,
  cursor: "pointer",
  marginBottom: 15
};

const cardStyle = {
  flex: 1,
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
};

const primaryBtn = {
  background: "var(--pg-secondary)",
  color: "#fff",
  padding: "10px 15px",
  borderRadius: 6,
  marginTop: 15,
  width: "100%",
  fontWeight: 600,
  fontSize: 15,
  cursor: "pointer",
  border: "none",
};

const actionIcon = {
  cursor: "pointer",
  marginRight: 12,
  color: "var(--pg-primary)",
};

const paginationStyle = {
  marginTop: 20,
  display: "flex",
  justifyContent: "center",
  gap: 6,
};
